const actionType = {
    GET_REFEXPLORER_RECORDS_SUCCESS: 'GET_REFEXPLORER_RECORDS_SUCCESS',
    GET_REFEXPLORER_RECORDS_FAILURE: 'GET_REFEXPLORER_RECORDS_FAILURE',
    GET_ALL_REFEXPLORER_NAMES_SUCCESS: 'GET_ALL_REFEXPLORER_NAMES_SUCCESS',
    GET_ALL_REFEXPLORER_NAMES_FAILURE: 'GET_ALL_REFEXPLORER_NAMES_FAILURE',
};
export default actionType;
